// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"c13e2b11","239":"e39fb35b","455":"b5c64c0b","578":"5dfd61e3","946":"1732d480"}[chunkId] + ".chunk.js";
};